import { CookieSetOptions } from "universal-cookie";

export const cookieSetOptions = (defaultCookieDomain?: string) => {
  let opts: CookieSetOptions = {
    secure: false,
    path: "/",
  };
  if (window.location.hostname !== "localhost") {
    opts.domain = defaultCookieDomain || import.meta.env.VITE_MAKO_COOKIE_DOMAIN || ".sendgrid.com";
    opts.sameSite = "lax";
  }
  if (process.env.NODE_ENV === "production") {
    opts.secure = true;
  }
  return opts;
};
